<!-- Author ミィン -->
<!-- 年金手帳再交付申請書 -->

<template>
  <div v-show="show">
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t('general.add')}}
        </el-button>
      </el-form-item>
    </el-form>

    <!-- Table -->
    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px"
      :empty-text="$t('general.empty_data')">

      <el-table-column :label="$t('pension_reissue.employee_id')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_id }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('pension_reissue.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('pension_reissue.phone_type')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.phone_type}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('pension_reissue.reason')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.reason}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('pension_reissue.system_name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.system_name }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('pension_reissue.report_date')" align="center">
        <template slot-scope="scope">
          <!-- <div slot="reference" class="name-wrapper">
            <el-button type="text" @click="handleDetails(scope.$index, scope.row)">{{ scope.row.report_date }}
            </el-button>
          </div> -->
          <span>{{ scope.row.report_date}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t('general.edit')}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t('general.delete')}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t('general.print')}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- New -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="55%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm" size="mini"
        style="margin-left:30px" :label-position="labelPosition">
        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item :label="$t('pension_reissue.employee_id')+':'" prop="employee_id">
                <el-select v-model="ruleForm.employee_id" clearable
                  style="margin-left:10px;margin-right:50px;width: 185px" size="mini"
                  :placeholder="$t('general.please_select')" @change="employeeIdSelected">
                  <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.report_date')+':'" prop="report_date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.report_date" size="mini"
                  value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date" placeholder="2020-03-11">
                </el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.phone_type')+':'" prop="phone_type">
                <el-select v-model="ruleForm.phone_type" clearable style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.please_select')">
                  <el-option v-for="item in phone_typeList" :key="item.id" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.reason')+':'" prop="reason">
                <el-select v-model="ruleForm.reason" style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.please_select')">
                  <el-option v-for="item in reasonList" :key="item.id" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
                <el-button class="el-icon-info" type="text" @click="open1">{{$t('general.hint')}}</el-button>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div>
              <el-form-item :label="$t('pension_reissue.name')+':'" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.name" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('pension_reissue.name')+':'" readonly>
                </el-input>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.system_name')+':'" prop="system_name">
                <el-select v-model="ruleForm.system_name" clearable style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.please_select')">
                  <el-option v-for="item in system_nameList" :key="item.id" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
                <el-button class="el-icon-info" type="text" @click="open3">{{$t('general.hint')}}</el-button>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.acquisition_date')+':'" prop="acquisition_date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.acquisition_date" size="mini"
                  value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date" placeholder="2020-03-11">
                </el-date-picker>
                <el-button class="el-icon-info" type="text" @click="open2">{{$t('general.hint')}}</el-button>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.loss_date')+':'" prop="loss_date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.loss_date" size="mini"
                  value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date" placeholder="2020-03-11">
                </el-date-picker>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t('general.confirm')}}</el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t('general.cancel')}}</el-button>
      </span>
    </el-dialog>

    <!-- Edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="55%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm" size="mini"
        style="margin-left:30px" :label-position="labelPosition">
        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item :label="$t('pension_reissue.employee_id')+':'" prop="employee_id">
                <el-select v-model="ruleForm.employee_id" clearable
                  style="margin-left:10px;margin-right:50px;width: 185px" size="mini"
                  :placeholder="$t('general.please_select')" @change="employeeIdSelected">
                  <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.report_date')+':'" prop="report_date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.report_date" size="mini"
                  value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date" placeholder="2020-03-11">
                </el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.phone_type')+':'" prop="phone_type">
                <el-select v-model="ruleForm.phone_type" clearable style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.please_select')">
                  <el-option v-for="item in phone_typeList" :key="item.id" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.reason')+':'" prop="reason">
                <el-select v-model="ruleForm.reason" clearable style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.please_select')">
                  <el-option v-for="item in reasonList" :key="item.id" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
                <el-button class="el-icon-info" type="text" @click="open1">{{$t('general.hint')}}</el-button>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div>
              <el-form-item :label="$t('pension_reissue.name')+':'" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.name" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('pension_reissue.name')+':'" readonly>
                </el-input>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.system_name')+':'" prop="system_name">
                <el-select v-model="ruleForm.system_name" clearable style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.please_select')">
                  <el-option v-for="item in system_nameList" :key="item.id" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
                <el-button class="el-icon-info" type="text" @click="open3">{{$t('general.hint')}}</el-button>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.acquisition_date')+':'" prop="acquisition_date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.acquisition_date" size="mini"
                  value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date" placeholder="2020-03-11">
                </el-date-picker>
                <el-button class="el-icon-info" type="text" @click="open2">{{$t('general.hint')}}</el-button>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.loss_date')+':'" prop="loss_date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.loss_date" size="mini"
                  value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date" placeholder="2020-03-11">
                </el-date-picker>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t('general.confirm')}}</el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t('general.cancel')}}</el-button>
      </span>
    </el-dialog>

    <!-- Detail -->
    <!-- <el-dialog :title="$t('general.detail')" :append-to-body="true" :visible.sync="dialogDetails" width="55%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm" size="mini"
        :label-position="labelPosition" style="margin-left:30px">
        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item :label="$t('pension_reissue.employee_id')+':'" prop="employee_id">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.employee_id" size="mini" readonly="readonly"
                  style="margin-left:10px;width: 185px"></el-input>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.report_date')+':'" prop="report_date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.report_date" size="mini"
                  value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date" placeholder="2020-03-11"
                  readonly="readonly"></el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.phone_type')+':'" prop="phone_type">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.phone_type" size="mini" readonly="readonly"
                  style="margin-left:10px;width: 185px"></el-input>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.reason')+':'" prop="reason">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.reason" size="mini" readonly="readonly"
                  style="margin-left:10px;width: 585px"></el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div>
              <el-form-item :label="$t('pension_reissue.system_name')+':'" prop="system_name">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.system_name" size="mini" readonly="readonly"
                  style="margin-left:10px;width: 185px"></el-input>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.acquisition_date')+':'" prop="acquisition_date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.acquisition_date" size="mini"
                  value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date" placeholder="2020-03-11"
                  readonly="readonly"></el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('pension_reissue.loss_date')+':'" prop="loss_date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.loss_date" size="mini"
                  value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date" placeholder="2020-03-11"
                  readonly="readonly"></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="cancel()" type="primary" size="medium">{{$t('general.cancel')}}
        </el-button>
      </span>
    </el-dialog> -->

    <br />

    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small
        layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        labelPosition: "left",
        phone_typeList: [{
            id: 1,
            name: "１．自宅",
            value: "１．自宅",
          },
          {
            id: 2,
            name: "２．携帯電話",
            value: "２．携帯電話",
          },
          {
            id: 3,
            name: "３．勤務先",
            value: "３．勤務先",
          },
          {
            id: 4,
            name: "４．その他",
            value: "４．その他",
          },
        ],
        reasonList: [{
            id: 1,
            name: "１．紛失",
            value: "１．紛失",
          },
          {
            id: 2,
            name: "２．破損（汚れ）",
            value: "２．破損（汚れ）",
          },
          {
            id: 3,
            name: "９．その他",
            value: "９．その他",
          },
        ],
        system_nameList: [{
            id: 1,
            name: "１．国民年金",
            value: "１．国民年金",
          },
          {
            id: 2,
            name: "２．厚生年金保険",
            value: "２．厚生年金保険",
          },
          {
            id: 3,
            name: "３．船員保険",
            value: "３．船員保険",
          },
          {
            id: 4,
            name: "４．共済組合",
            value: "４．共済組合",
          },
        ],
        ruleForm: {
          id: "",
          report_date: "",
          phone_type: "",
          reason: "",
          system_name: "",
          acquisition_date: "",
          loss_date: "",
          employee_id: "",
          name: "",
        },
        rules: {
          reason: [{
            required: true,
            message: this.$t("pension_reissue.enter_reason"),
            trigger: "blur",
          }, ],
        },
        tableData: [],
        search: "",
        dialogVisible: false,
        dialogUpdate: false,
        dialogDetails: false,
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false,
        empListTemp: [],
        emp: {
          id: "",
          employee_id: "",
          name: "",
          name_rm: "",
          name_frgn: "",
          post_code: "",
          birthday: "",
          birthday: "",
          gender: "",
          email: "",
          mynum: "",
          work_status: "",
          begin_date: "",
          end_date: "",
          cause: "",
          employee_type: "",
          title: "",
          work_content: "",
          address1: "",
          address2: "",
          address3: "",
          address_kn1: "",
          address_kn2: "",
          address_kn3: "",
          tel: "",
          bank_name: "",
          bank_branch: "",
          deposit_type: "",
          account: "",
          account_name: "",
          emp_insuranceID: "",
          emp_ins_begin_day: "",
          emp_ins_end_day: "",
          pensionID: "",
          health_insuranceID: "",
          basic_pensionID: "",
          salary_changeday: "",
          salary_month: "",
          commuting_fee: "",
          nation: "",
          resident: "",
          resident_code: "",
        },
        empList: {
          id: "",
          employee_id: "",
          name: "",
          name_rm: "",
          name_frgn: "",
          post_code: "",
          birthday: "",
          birthday: "",
          gender: "",
          email: "",
          mynum: "",
          work_status: "",
          begin_date: "",
          end_date: "",
          cause: "",
          employee_type: "",
          title: "",
          work_content: "",
          address1: "",
          address2: "",
          address3: "",
          address_kn1: "",
          address_kn2: "",
          address_kn3: "",
          tel: "",
          bank_name: "",
          bank_branch: "",
          deposit_type: "",
          account: "",
          account_name: "",
          emp_insuranceID: "",
          emp_ins_begin_day: "",
          emp_ins_end_day: "",
          pensionID: "",
          health_insuranceID: "",
          basic_pensionID: "",
          salary_changeday: "",
          salary_month: "",
          commuting_fee: "",
          nation: "",
          resident: "",
          resident_code: "",
        },
      };
    },
    methods: {
      preview(index, row) {
        var uid = window.localStorage.getItem('LoginUserId');
        window.open("/pdf/年金手帳再交付申請書-" + "uid=" + uid + ".pdf");
      },
      employeeIdSelected() {
        // console.log(this.ruleForm.employee_id);
        let postData = this.qs.stringify({
          employee_id: this.ruleForm.employee_id,
        });
        this.axios({
            method: "post",
            url: "/ListEmpList",
            data: postData,
          })
          .then((response) => {
            // console.log(response.data);
            this.empListTemp = response.data;
            this.emp = this.empListTemp[0];
            this.ruleForm.name = this.emp.name;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      open1() {
        const h = this.$createElement;
        this.$notify({
          title: this.$t("pension_reissue.acquisition_date"),
          message: h(
            "i", {
              style: "color: teal",
            },
            this.$t("pension_reissue.hint_open1")
          ),
        });
      },
      open2() {
        const h = this.$createElement;
        this.$notify({
          title: this.$t("pension_reissue.reason"),
          message: h(
            "i", {
              style: "color: teal",
            },
            this.$t("pension_reissue.hint_open2")
          ),
        });
      },
      open3() {
        const h = this.$createElement;
        this.$notify({
          title: this.$t("pension_reissue.system_name"),
          message: h(
            "i", {
              style: "color: teal",
            },
            this.$t("pension_reissue.hint_open3")
          ),
        });
      },
      printPDF(index, row) {
        let postData = this.qs.stringify({
          id: row.id,
        });
        this.axios({
            method: "post",
            url: "/PensionReissuePDF",
            data: postData,
          })
          .then((response) => {
            this.handleCurrentChange();
            this.$message({
              type: "success",
              message: this.$t("general.print_completed"),
            });
            setTimeout(() => {
              this.preview(index, row);
            }, 700);
            // console.log(response);
          })
          .catch((error) => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed"),
            });
            console.log(error);
          });
      },
      handleEdit(index, row) {
        this.dialogUpdate = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleDetails(index, row) {
        this.dialogDetails = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleDelete(index, row) {
        // console.log(index, row);
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonClass: "btn-custom-confirm",
            confirmButtonText: "OK",
            cancelButtonText: this.$t("general.cancel"),
            type: "warning",
          })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id,
            });
            this.axios({
                method: "post",
                url: "/deletePensionReissue",
                data: postData,
              })
              .then((response) => {
                this.getPages();
                this.currentPage = 1;
                this.axios
                  .post("/pagePensionReissue")
                  .then((response) => {
                    this.tableData = response.data;
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed"),
                });
                // console.log(response);
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled"),
            });
          });
      },
      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm"), {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonClass: "btn-custom-confirm",
            confirmButtonText: this.$t("general.confirm"),
            cancelButtonText: this.$t("general.cancel"),
            type: "warning",
          })
          .then((_) => {
            this.emptyUserData();
            done();
          })
          .catch((_) => {});
      },
      handleCurrentChange() {
        // console.log(`this.$t("general.current_page"): ${this.currentPage}`);
        let postData = this.qs.stringify({
          page: this.currentPage,
        });
        this.axios({
            method: "post",
            url: "/pagePensionReissue",
            data: postData,
          })
          .then((response) => {
            this.tableData = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      cancel() {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.emptyUserData();
      },
      s1_cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.emptyUserData();
        this.$refs[formName].resetFields();
      },
      emptyUserData() {
        this.ruleForm = {
          id: "",
          report_date: "",
          phone_type: "",
          reason: "",
          system_name: "",
          acquisition_date: "",
          loss_date: "",
          employee_id: "",
          name: "",
        };
      },
      addUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              report_date: this.ruleForm.report_date,
              phone_type: this.ruleForm.phone_type,
              reason: this.ruleForm.reason,
              system_name: this.ruleForm.system_name,
              acquisition_date: this.ruleForm.acquisition_date,
              loss_date: this.ruleForm.loss_date,
              employee_id: this.ruleForm.employee_id,
            });
            this.axios({
                method: "post",
                url: "/insertPensionReissue",
                data: postData,
              })
              .then((response) => {
                this.axios
                  .post("/pagePensionReissue")
                  .then((response) => {
                    this.tableData = response.data;
                    this.currentPage = 1;
                    this.s1_cancel(ruleForm);
                    this.$message({
                      type: "success",
                      message: this.$t("general.add_completed"),
                    });
                  })
                  .catch((error) => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.add_failed"),
                    });
                    console.log(error);
                  });
                this.getPages();
                this.dialogVisible = false;
                // console.log(response);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message.error('必須項目が入力されていません');
            return false;
          }
        });
      },
      updateUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleForm.id,
              report_date: this.ruleForm.report_date,
              phone_type: this.ruleForm.phone_type,
              reason: this.ruleForm.reason,
              system_name: this.ruleForm.system_name,
              acquisition_date: this.ruleForm.acquisition_date,
              loss_date: this.ruleForm.loss_date,
              employee_id: this.ruleForm.employee_id,
            });
            this.axios({
                method: "post",
                url: "/updatePensionReissue",
                data: postData,
              })
              .then((response) => {
                this.handleCurrentChange();
                // this.s1_cancel(ruleForm);
                this.cancel();
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed"),
                });
                // console.log(response);
              })
              .catch((error) => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.edit_failed"),
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message.error('必須項目が入力されていません');
            return false;
          }
        });
      },
      getPages() {
        this.axios
          .post("/rowsPensionReissue")
          .then((response) => {
            this.total = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      },
    },
    created() {
      this.axios
        .post("/pagePensionReissue")
        .then((response) => {
          // console.log(response.data);
          this.tableData = response.data;
          this.show = true;
        })
        .catch((error) => {
          this.show = false;
          this.$message({
            type: 'error',
            message: '開発中です。'
          });
          console.log(error);
        });

      this.axios
        .post("/rowsPensionReissue")
        .then((response) => {
          this.total = response.data;
        })
        .catch((error) => {
          console.log(error);
        });

      this.axios
        .post("/ListEmpListForInsNameChange")
        .then((response) => {
          // console.log(response.data);
          this.empList = response.data;
          // console.log(this.empList);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  };
</script>

<style scoped>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    width: 90px;
  }

  .btn-custom-confirm {
    width: 90px;
  }

  .search_name {
    width: 200px;
  }

  .item1 {
    visibility: hidden;
  }

  .item2 {
    visibility: hidden;
  }

  .style1 {
    margin-right: 145px;
    padding: 0px;
    text-align: right;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/SocialIns/PensionReissue.vue